export enum NotificationType {
  warning = 'warning',
  error = 'error',
  info = 'info',
}

export type NotificationElements = {
  icon: JSX.Element;
  backgroundColor: string;
  backgroundBorderColor: string;
  contentColor: string;
  defaultTitle: string;
};
